import './style.scss';

import ButtonC, { BUTTON_ALIGN_LABEL, BUTTON_HOVERSTYLE } from 'components/ButtonC';
import { LINK_TARGET, LinkTargetTypes } from 'components/Link';
import { forwardRef } from 'react';

type MenuItemProps = {
  text?: string;
  icon?: string;
  onClick?: () => void;
  href?: string;
  target?: LinkTargetTypes;
  badge?: string;
};

const MenuItem = forwardRef<HTMLButtonElement | HTMLAnchorElement, MenuItemProps>(
  (
    { text, icon, href, onClick = () => {}, target = LINK_TARGET.BLANK, badge }: MenuItemProps,
    ref,
  ) => {
    return (
      <li className="menu__list-item">
        {href ? (
          <ButtonC
            ref={ref}
            hoverStyle={BUTTON_HOVERSTYLE.ICON}
            fullwidth
            icon={icon}
            href={href}
            target={target}
            onClick={onClick}
            alignLabel={BUTTON_ALIGN_LABEL.LEFT}
            labelBold={false}
            noPaddingSide
            transformLabelToUppercase={false}
            className="menu-item__button">
            {text}
            {badge && <span className="badge">{badge}</span>}
          </ButtonC>
        ) : (
          <ButtonC
            ref={ref}
            hoverStyle={BUTTON_HOVERSTYLE.ICON}
            fullwidth
            icon={icon}
            onClick={onClick}
            alignLabel={BUTTON_ALIGN_LABEL.LEFT}
            labelBold={false}
            noPaddingSide
            transformLabelToUppercase={false}
            className="menu-item__button">
            {text}
            {badge && <span className="badge">{badge}</span>}
          </ButtonC>
        )}
      </li>
    );
  },
);

export default MenuItem;
